import { IconHome, IconFilePencil, IconCalendarEvent } from '@tabler/icons-react';
import superAdminMenu from './superAdminMenu';
import BTCMenu from './BTCMenu';
import { uniqueId } from 'lodash';

const roles = localStorage.getItem('roles');
const isImpersonation = localStorage.getItem('isImpersonation');

const Menuitems = isImpersonation || roles === 'BTC' ? BTCMenu : superAdminMenu;

export default Menuitems;
